import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGasFlare = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 100,
	viewBox: "0 0 60.0 100.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 0.0 100.0 L 60.0 100.0 M 30.0 25.0 A 15.0 15.0 0.0 0 1 30.0 0.0 A 15.0 15.0 0.0 0 1 30.0 25.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("rect", {
		x: 20,
		y: 25,
		width: 20,
		height: 75,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgGasFlare;
